export default __webpack_public_path__ + "static/media/1C4RU5.797e86e6.png";